export const handleContactUs = () => {
    window.location.href = 'mailto:hello@promptfolio.ai';
};
